import { combineReducers } from 'redux';
import businessTypeReducer from './BusinessType/slice';
import generalInfoReducer from './GeneralInfo/slice';
import ownersReducer from './Owners/slice';
import industryandprimaryactivityReducer from './Industryandprimaryactivity/slice';


export default combineReducers({
  businessType : businessTypeReducer,  
generalInfo : generalInfoReducer,  
owners : ownersReducer,  
industryandprimaryactivity : industryandprimaryactivityReducer,  

});
